module.exports = __webpack_public_path__ + "fonts/fa-solid-900.8ac31674.eot";